<main class="confirmed">
  <div class="confirmed__panel">
    <img
      class="confirmed__mascot"
      ngSrc="/images/logo/cart_success.png"
      width="640"
      height="457"
      alt=""
      priority
    />
    <h1 class="confirmed__title">{{ copy.CONFIRMED_TITLE }}</h1>
    <p class="confirmed__body">{{ copy.CONFIRMED_BODY }}</p>
    <app-button variant="primary" [routerLink]="copy.CONFIRMED_CTA_HREF">
      {{ copy.CONFIRMED_CTA }}
    </app-button>
  </div>
</main>
